import { render, staticRenderFns } from "./RsaPaiSpecializzazioneListComponent.vue?vue&type=template&id=4dc6104e"
import script from "./RsaPaiSpecializzazioneListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPaiSpecializzazioneListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports